import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import { Tag } from 'antd';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';

function stageCell(visibleColumns: any) {
  if (!visibleColumns.includes('stage')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Stage', { ns: 'sales' })} />,
    dataIndex: ['stage'],
    key: 'stage',
    render: (stage: any) => <StageDisplay stage={stage} />,
    width: 120,
  };
}

const StageDisplay = ({ stage }: { stage?: string }) => {
  if (!stage) return <span>-</span>;

  const getStageColor = (stage: string) => {
    switch (stage.toLowerCase()) {
      case 'new':
      case 'lead':
        return 'blue';
      case 'qualified':
        return 'green';
      case 'contacted':
        return 'orange';
      case 'converted':
        return 'success';
      case 'lost':
        return 'red';
      default:
        return 'default';
    }
  };

  return <Tag color={getStageColor(stage)}>{stage}</Tag>;
};

export default stageCell;
